export enum SystemLogType {
    Info = 1,
    Warning = 2,
    Error = 4,
    Critical = 8
}

export class GsbSystemLog {
    _entDefName?: string;
    public id?: string;
    public dto?: string;
    public createDate?: Date;
    public type?: SystemLogType;
    public message?: string;
    public title?: string;
    public operation?: string;
    public exception?: string;

    constructor(obj?: Partial<GsbSystemLog>) {
        Object.assign(this, obj);
        this._entDefName = "GsbSystemLog";
    }
} 